import { Paragraph } from "@vfuk/core-paragraph";
import { Tooltip } from "../Tooltip";

type TruncatedTextProps = {
  children: string;
  maxLength: number;
};

// Returns a truncated paragraph with a tooltip
const TruncatedText = ({ children, maxLength }: TruncatedTextProps) => {
  if (children.length > maxLength) {
    return (
      <Tooltip content={children}>
        <span>
          <Paragraph>{children.slice(0, maxLength)}...</Paragraph>
        </span>
      </Tooltip>
    );
  }

  return <Paragraph>{children}</Paragraph>;
};

export default TruncatedText;
